import { render, staticRenderFns } from "./UpdateCompanyIntroduction.vue?vue&type=template&id=79c60e5d&scoped=true"
import script from "./UpdateCompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c60e5d",
  null
  
)

export default component.exports